
let copyToClipboard = async (text) => {
    if (navigator.clipboard) {
        await navigator.clipboard.writeText(text)
    } else {

    }
}

export default copyToClipboard